import React from 'react';
import { Link } from 'react-router-dom';
import {
  Phone,
  MessageCircle,
  MapPin,
  Facebook,
  Instagram,
  Twitter,
  Linkedin
} from 'lucide-react';
import { companyInfo } from '../mock';
import logo from '../assets/logo.png';

const Footer = () => {
  const handleWhatsApp = () => {
    window.open(
      `https://wa.me/91${companyInfo.whatsapp}?text=Hi, I'm interested in your properties`,
      '_blank'
    );
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer bg-[#020617] border-t border-white/10 relative">
      <div className="container mx-auto px-4 py-16">

        {/* TOP GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* LOGO + ABOUT */}
          <div>
            <Link to="/" className="inline-block mb-6">
              <img
                src={logo}
                alt="UNITYPRO HOMES Logo"
                className="h-14 w-auto object-contain bg-transparent"
              />
            </Link>

            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Delhi's trusted property developers specializing in premium plots,
              homes, and commercial spaces.
            </p>

            <div className="flex space-x-3">
              <a href="#" className="social-icon"><Facebook size={18} /></a>
              <a href="#" className="social-icon"><Instagram size={18} /></a>
              <a href="#" className="social-icon"><Twitter size={18} /></a>
              <a href="#" className="social-icon"><Linkedin size={18} /></a>
            </div>
          </div>

          {/* QUICK LINKS */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="footer-link">Home</Link></li>
              <li><Link to="/properties" className="footer-link">Properties</Link></li>
              <li><Link to="/about" className="footer-link">About Us</Link></li>
              <li><Link to="/contact" className="footer-link">Contact</Link></li>
            </ul>
          </div>

          {/* SERVICES */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Our Services</h4>
            <ul className="space-y-3 text-gray-400 text-sm">
              <li>Residential Plots</li>
              <li>Homes & Villas</li>
              <li>Farmhouses</li>
              <li>Commercial Shops</li>
              <li>Property Management</li>
              <li>Legal Assistance</li>
            </ul>
          </div>

          {/* CONTACT */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Contact Us</h4>

            <div className="space-y-4 text-sm text-gray-400">
              <div className="flex items-start">
                <MapPin className="w-5 h-5 text-cyan-400 mr-3 mt-1" />
                <p>{companyInfo.address}</p>
              </div>

              <div>
                {companyInfo.phones.map((phone, idx) => (
                  <a
                    key={idx}
                    href={`tel:+91${phone}`}
                    className="block footer-link mb-1"
                  >
                    +91 {phone}
                  </a>
                ))}
              </div>

              <button
                onClick={handleWhatsApp}
                className="footer-link flex items-center gap-2"
              >
                <MessageCircle size={18} />
                WhatsApp Us
              </button>
            </div>
          </div>
        </div>

        {/* DIRECTOR */}
        <div className="border-t border-white/10 mt-14 pt-8 text-center">
          <p className="text-gray-400">
            <span className="text-cyan-400 font-semibold">
              {companyInfo.managingDirector}
            </span>{' '}
            — {companyInfo.designation}
          </p>
          <p className="text-gray-500 text-sm mt-1">
            Leading {companyInfo.name} with excellence and integrity
          </p>
        </div>

        {/* BOTTOM BAR */}
        <div className="border-t border-white/10 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
          <p>
            © {currentYear} {companyInfo.name}. All rights reserved.
          </p>

          <div className="flex gap-6 mt-4 md:mt-0">
            <a href="#" className="footer-link">Privacy Policy</a>
            <a href="#" className="footer-link">Terms</a>
            <a href="#" className="footer-link">Sitemap</a>
          </div>
        </div>
      </div>

      {/* FLOATING WHATSAPP */}
      <button
        onClick={handleWhatsApp}
        className="floating-whatsapp"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle className="w-6 h-6" />
      </button>
    </footer>
  );
};

export default Footer;
